import React from 'react';

const UserProfilePage = ({}) => {
    return (
        <h1>用户信息页</h1>
    )
};

export default UserProfilePage;
